export interface EmailProvider {
  id: string;
  name: string;
  logo?: string; // Path to logo image
  host: string;
  port: number;
  useSsl: boolean;
  useTls: boolean;
  bgColor: string;
  textColor: string;
  setupGuideUrl?: string;
  note?: string;
  isOAuth?: boolean;
}

export const EMAIL_PROVIDERS: EmailProvider[] = [
  {
    id: 'gmail-oauth',
    name: '',
    logo: '/providers/logo_gmail_lockup_default_1x_r5.png',
    host: 'smtp.gmail.com',
    port: 587,
    useSsl: false,
    useTls: true,
    bgColor: 'bg-white',
    textColor: 'text-gray-800',
    setupGuideUrl: 'https://support.google.com/mail/answer/7126229',
    isOAuth: true,
    note: "Utilisez un mot de passe d'application si 2FA est activé",
  },
  {
    id: 'outlook',
    name: 'Outlook',
    logo: '/providers/outlook.svg',
    host: 'smtp-mail.outlook.com',
    port: 587,
    useSsl: false,
    useTls: true,
    bgColor: 'bg-[#0078D4]',
    textColor: 'text-white',
  },
  {
    id: 'ovh',
    name: '',
    logo: '/providers/ovhcloud-logo2.png',
    host: 'ssl0.ovh.net',
    port: 587,
    useSsl: false,
    useTls: true,
    bgColor: 'bg-[#000E9C]',
    textColor: 'text-white',
  },
  {
    id: 'ionos',
    name: '',
    logo: '/providers/ionos.svg',
    host: 'smtp.ionos.fr',
    port: 465,
    useSsl: true,
    useTls: false,
    bgColor: 'bg-[#001b41]',
    textColor: 'text-white',
  },
  {
    id: 'hostinger',
    name: '',
    logo: '/providers/hostinger.svg',
    host: 'smtp.hostinger.com',
    port: 465,
    useSsl: true,
    useTls: false,
    bgColor: 'bg-[#6747c7]',
    textColor: 'text-white',
  },
  {
    id: 'godaddy',
    name: '',
    logo: '/providers/godaddy.svg',
    host: 'smtpout.secureserver.net',
    port: 465,
    useSsl: true,
    useTls: false,
    bgColor: 'bg-[#a6fff8]',
    textColor: 'text-black',
  },
  {
    id: 'lws',
    name: '',
    logo: '/providers/lws.svg',
    host: '',
    port: 587,
    useSsl: false,
    useTls: true,
    bgColor: 'bg-white',
    textColor: 'text-black',
  },
  {
    id: 'coaxis',
    name: 'Coaxis',
    logo: undefined,
    host: 'vdmzbm6.coaxis.com',
    port: 587,
    useSsl: false,
    useTls: true,
    bgColor: 'bg-white',
    textColor: 'text-black',
    note: 'Serveur utilisé par certains cabinets déjà enregistrés.',
  },
  {
    id: 'microsoft365-oauth',
    name: 'Microsoft 365',
    logo: '/providers/microsoft365.svg',
    host: 'smtp.office365.com',
    port: 587,
    useSsl: false,
    useTls: true,
    bgColor: 'bg-[#0078D4]',
    textColor: 'text-white',
    isOAuth: true,
    note: 'Connexion sécurisée via OAuth 2.0',
  },
  {
    id: 'other',
    name: 'Autre',
    logo: undefined,
    host: '',
    port: 587,
    useSsl: false,
    useTls: true,
    bgColor: 'bg-muted',
    textColor: 'text-muted-foreground',
  },
];

/**
 * Get email provider by ID
 */
export function getEmailProvider(id: string): EmailProvider | undefined {
  return EMAIL_PROVIDERS.find(p => p.id === id);
}
